import { fetcher } from '@commenda/utils';
import { templateVersionsUrl } from './helpers';

// Marks a PUBLISHED version active by repointing template.activeVersionId. Nothing happens to the
// version that was active: it stays PUBLISHED and is not modified. Archiving is a separate act.
export const activateDocumentAssemblerTemplateVersion = async (
  templateId: string,
  versionId: string
): Promise<Response> => {
  const res = await fetcher(
    `${templateVersionsUrl(templateId)}/${versionId}/activate`,
    { method: 'POST', body: {} }
  );
  return res;
};
